import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const FlipCardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;

  @media (min-width: 600px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

const FlipCard = styled.div`
  background-color: transparent;
  width: 450px;
  height: 270px;
  perspective: 1000px;
  flex: 1 1 300px;
`;

const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
  cursor: pointer;

  ${FlipCard}:hover & {
    transform: rotateY(180deg);
  }

  @media (hover: none) {
    &:active {
      transform: rotateY(180deg);
    }
  }
`;

const CardFace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 15px;
  backface-visibility: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  overflow: hidden;
`;

const Front = styled(CardFace)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f0f0f0;
  color: white;
  transition: opacity 0.4s ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 15px;
    background: rgba(0, 0, 0, 0.4); /* subtle overlay */
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  ${FlipCard}:hover &,
  ${FlipCard}:active & {
    opacity: 0;
    pointer-events: none;
  }
`;

const Back = styled(CardFace)`
  transform: rotateY(180deg);
  text-align: left;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
`;

const Title = styled.h3`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const BulletList = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 0;
  max-height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  li {
    margin-bottom: 0.6rem;
    font-size: 0.95rem;
  }
`;

const ATLTinckerpreneurFlip = () => {
  const { t } = useTranslation();

  const cards = [
    {
      title: t("atl_tinkerpreneur.section_1_title"),
      content: [t("atl_tinkerpreneur.section_1_content_2")],
      image: "images/who_can_participate.JPG",
    },
    {
      title: t("atl_tinkerpreneur.section_2_title"),
      content: [
        t("atl_tinkerpreneur.section_2_content_1"),
        t("atl_tinkerpreneur.section_2_content_2"),
        t("atl_tinkerpreneur.section_2_content_3"),
        t("atl_tinkerpreneur.section_2_content_4"),
      ],
      image: "images/How_to_participate.JPG",
    },
    {
      title: t("atl_tinkerpreneur.section_3_title"),
      content: [t("atl_tinkerpreneur.section_3_content_1")],
      image: "images/why_to_participate.JPG",
    },
  ];

  return (
    <FlipCardContainer>
      {cards.map((card, index) => (
        <FlipCard key={index}>
          <FlipCardInner>
            <Front style={{ backgroundImage: `url(${card.image})` }}>
              <Icon>{card.icon}</Icon>
              <h2 className="text-white">{card.title}</h2>
            </Front>
            <Back>
              <Title>{card.title}</Title>
              {index === 0 || index === 2 ? (
                // Plain text for 1st and 3rd cards
                <p>{card.content[0]}</p>
              ) : (
                <BulletList>
                  {card.content.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </BulletList>
              )}
            </Back>
          </FlipCardInner>
        </FlipCard>
      ))}
    </FlipCardContainer>
  );
};

export default ATLTinckerpreneurFlip;
